import { Icon } from '@assembly-js/design-system';
import { SvgIconProps } from '@mui/material';

export const SignatureTextIcon = ({ className, style }: SvgIconProps) => (
  <Icon
    icon="font-case"
    className={className}
    style={{ width: '1em', height: '1em', ...style }}
  />
);
